import { collection, doc, getDoc, getDocs, query, where } from 'firebase/firestore';
import { db } from '../firebaseConfig';

export interface ClinicDoctorOption {
  id: string;
  name: string;
}

/** Read-only list of doctors linked to one clinic. Falls back to the signed-in doctor for legacy clinics. */
export async function getClinicDoctorOptions(
  clinicId: string | null | undefined,
  fallbackDoctorId: string | null | undefined,
  fallbackDoctorName = ''
): Promise<ClinicDoctorOption[]> {
  const cid = String(clinicId || '').trim();
  const fallbackId = String(fallbackDoctorId || '').trim();
  if (!cid || cid === '__all_clinics__') {
    return fallbackId ? [{ id: fallbackId, name: fallbackDoctorName || fallbackId }] : [];
  }

  try {
    const links = await getDocs(query(
      collection(db, 'doctor_clinic_assistant'),
      where('clinic_id', '==', cid)
    ));
    const ids = Array.from(new Set(
      links.docs.map((item) => String(item.data()?.doctor_id || '').trim()).filter(Boolean)
    ));
    if (fallbackId && !ids.includes(fallbackId)) ids.push(fallbackId);

    const profiles = await Promise.all(ids.map(async (id) => {
      const snapshot = await getDoc(doc(db, 'doctors', id));
      const data = snapshot.exists() ? snapshot.data() : null;
      return { id, name: String(data?.name || data?.doctor_name || (id === fallbackId ? fallbackDoctorName : '') || id) };
    }));
    return profiles.sort((a, b) => a.name.localeCompare(b.name, 'ar'));
  } catch (error) {
    console.error('[clinicDoctors] Failed to load clinic doctors:', error);
    return fallbackId ? [{ id: fallbackId, name: fallbackDoctorName || fallbackId }] : [];
  }
}
